import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function loginRequest({ username, password }) {
  return await api.post(
    generatePath('/user/login'),
    { username, password },
    config('json')
  );
}
